import type { RouteRecordRaw } from 'vue-router'

const interviewsRoutes: RouteRecordRaw[] = [
  {
    path: '/public-interviews/:hash',
    name: 'PublicInterview',
    meta: {
      hideHeader: true,
      hideFooter: true
    },
    component: () => import('./PublicInterviewsHome.vue')
  }
]

export default interviewsRoutes
